import * as React from 'react';
import '../UserTableRow.css';
import { Link } from 'react-router-dom';
import OutwardIntegrationResult from '../../domain/OutwardIntegrationResult';
import utcToLocalTime from './integration/utcToLocalTime';
import reload from './reload.svg';
import Tooltip from '../tooltip/Tooltip';
import info from './info.svg';

interface Props {
    data: OutwardIntegrationResult;
    type: 'orders' | 'estimations';
    retrySendOrder?: (orderId: number) => void;
}

export default class TableRow extends React.PureComponent<Props> {
    public render(): JSX.Element {
        const rowLink = `/admin/customers/${this.props.data.userId}/${this.props.type}/${this.props.data.id}`;
        return (
            <div className="user-table-details-row">
                <div>
                    <Link to={rowLink}>{this.props.data.id}</Link>
                </div>
                <div>
                    <span>{this.props.data.userId}</span>
                </div>
                <div>
                    {this.isRejectedAndErrorExist() ? (
                        <Tooltip message={this.parseError()} enabled={true}>
                            <span>{this.props.data.status}</span>
                            <img className="details-info" src={info} />
                        </Tooltip>
                    ) : (
                        <span>{this.props.data.status}</span>
                    )}
                </div>
                <div>
                    <span>{this.props.data.placeDate}</span>
                </div>
                <div>
                    <span>{this.props.data.sendTime && utcToLocalTime(this.props.data.sendTime)}</span>
                </div>
                <div className="user-table-retry">
                    {this.shouldShowReload() && (
                        <a onClick={this.retry}>
                            <img src={reload} />
                            Retry
                        </a>
                    )}
                </div>
            </div>
        );
    }

    private retry = (): void => {
        if (this.props.retrySendOrder) {
            this.props.retrySendOrder(this.props.data.id);
        }
    };

    private shouldShowReload = (): boolean =>
        !!(
            this.props.type === 'orders' &&
            this.props.data.status === 'rejected' &&
            this.props.data.integrationError &&
            !this.props.data.integrationError.autoRetryable
        );

    private isRejectedAndErrorExist = (): boolean =>
        this.props.data.status === 'rejected' && this.props.data.integrationError !== undefined;

    private parseError = (): string => {
        const regex = `<status code="ERROR">(.*?)<\/status>`.toString();
        if (this.props.data.integrationError!.error.match(regex)) {
            return this.props.data
                .integrationError!.error.match(regex)!
                .toString()
                .split(',')[1];
        } else if (this.props.data.integrationError!.error.indexOf('The operation has timed out') !== -1) {
            return 'The operation has timed out';
        } else {
            return this.props.data.integrationError!.error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/view/admin/TableRow.tsx